/**
 * Wall-clock timer for the Screen Recorder. The old timer counted setInterval ticks, which browsers delay while the tab is in the
 * background (the normal case when you are recording another window), so the live timer ran behind the file. This one is
 * measured from the clock, starts when recording really starts and leaves out paused time, like the recorded file does.
 */
export class RecordingClock {
  private startedAt: number | null = null;
  private banked = 0;

  /** Call when recording actually starts (MediaRecorder start event). Resets any earlier run. */
  start(nowMs: number): void { this.startedAt = nowMs; this.banked = 0; }
  pause(nowMs: number): void {
    if (this.startedAt === null) return;
    this.banked += nowMs - this.startedAt;
    this.startedAt = null;
  }
  resume(nowMs: number): void { if (this.startedAt === null) this.startedAt = nowMs; }
  /** Milliseconds recorded so far, paused time excluded. */
  elapsedMs(nowMs: number): number { return this.banked + (this.startedAt === null ? 0 : nowMs - this.startedAt); }
  /** Stops the clock and returns the final length in milliseconds. */
  stop(nowMs: number): number { this.pause(nowMs); return this.banked; }
  reset(): void { this.startedAt = null; this.banked = 0; }
}

/** Whole seconds shown while recording (counts up as each second completes). */
export const liveSeconds = (ms: number): number => Math.floor(ms / 1000);
/** Whole seconds shown for a finished recording: rounded, so it is within 0.5 s of the file length. */
export const finalSeconds = (ms: number): number => Math.round(ms / 1000);
